import { useLayoutEffect, useRef, useEffect, useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/home/logo-border.webp";

export default function Header() {
    const location = useLocation(),
        headerLinksRef = useRef(null);
    const [isDark, setIsDark] = useState(false);

    useLayoutEffect(() => {
        document.documentElement.setAttribute("data-location", location.pathname.replace(/(?<!^)\/$/, ""));
        headerLinksRef.current?.querySelectorAll("a").forEach((link) => {
            if ((link.getAttribute("href") === "/" && document.documentElement.getAttribute("data-location") === "/") || (document.documentElement.getAttribute("data-location") !== "/" && link.getAttribute("href") !== "/" && document.documentElement.getAttribute("data-location").startsWith(link.getAttribute("href")))) {
                link.classList.add("active");
            } else {
                link.classList.remove("active");
            }
        });
    }, [location]);

    useEffect(() => {
        /* const dark = localStorage.getItem("isDark") === "true";
        if (dark) {
            document.documentElement.classList.add("dark");
        } */
        setIsDark(false);
    }, []);

    const toggleTheme = () => {
        /* document.documentElement.classList.toggle("dark");
        const dark = document.documentElement.classList.contains("dark");
        localStorage.setItem("isDark", dark);
        setIsDark(dark); */
    };
    return (
        <>
            <div id="header">
                <Link to="/" className="headerLogo">
                    <img src={logo} alt="Logo ČSA" draggable="false" />
                </Link>
                <div id="headerLinks" ref={headerLinksRef}>
                    <Link to="/">o straně</Link>
                    <Link to="clenove">členové</Link>
                    <Link to="pomoc">chci být součástí</Link>
                    <Link to="volby">volby</Link>
                </div>
                <button className="material-symbols-outlined" onClick={toggleTheme} style={{ display: "none" }}>
                    {isDark ? "dark_mode" : "light_mode"}
                </button>
            </div>
        </>
    );
}